import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProductionItemRequestActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ItemRequestReport/ItemRequestReport")
	}

	render() {
		return (
			<Activity 
				name="ItemRequestReport"
				RenderedComponent={this.RenderedComponent}
				context="ItemRequestReport"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductionItemRequestActivity)
